"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store/store';

/* Sin `VUE_APP_API` el panel se iba en silencio a localhost:8000 y no respondía
   nada. Pasó de verdad: un build hecho en un worktree de git no encuentra el
   `.env.beta` (no estaba versionado) y este respaldo se lo tragaba sin decir nada.
   El respaldo sigue —hace falta para el `npm run serve` de siempre— pero en un
   bundle ya construido eso NO puede pasar desapercibido. */
if (!process.env.VUE_APP_API && process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-console
    console.error(
        '[WACheckin] Este bundle se construyó SIN VUE_APP_API: las llamadas irán a ' +
        'localhost y no funcionará nada. Reconstruye con el --mode correcto ' +
        '(p. ej. `vue-cli-service build --mode beta`) y con su fichero .env.<modo>.'
    );
}

axios.defaults.baseURL = process.env.VUE_APP_API || 'http://localhost:8000/api';

if (store.state.token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token;
}
// axios.defaults.headers.common['Authorization'] = store.state.token;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    function(error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;